import Question from '../../../components/Question/Question';
import QuizFeedback from './QuizFeedback';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// todo: change onClick to link when migrating to UIComponent v2's (using linkComponent)
const QuizQuestion = ({
  answers,
  correctAnswer,
  feedbackText,
  hasAnswered,
  id,
  image,
  onSelectAnswer,
  onTryAgainClick,
  selectedAnswerIds,
  title,
  type
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "quiz-question",
    children: [/*#__PURE__*/_jsx("h2", {
      className: "quiz-question__line-break",
      "data-test-id": "question-name",
      children: title
    }), hasAnswered ? /*#__PURE__*/_jsx(QuizFeedback, {
      correctAnswer: correctAnswer,
      onTryAgainClick: onTryAgainClick,
      children: feedbackText
    }) : /*#__PURE__*/_jsx(Question, {
      answers: answers,
      id: id,
      image: image,
      onSelectAnswer: onSelectAnswer,
      selectedAnswerIds: selectedAnswerIds,
      type: type
    })]
  });
};
export default QuizQuestion;